import { Theme } from "PFApp/theme_context_provider/theme_context_provider.types";

export const getTheme = (isThemeEnabled: boolean) => {
  if (typeof window === "undefined" || !isThemeEnabled) {
    return Theme.Light;
  }

  const savedTheme = localStorage.getItem("theme") as Theme | null;
  if (savedTheme && Object.values(Theme).includes(savedTheme as Theme)) {
    return savedTheme as Theme;
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches ? Theme.Dark : Theme.Light;
};
